import {AuthoringSupplementModelV1} from 'resources/FrozenModels/AuthoringSupplement/AuthoringSupplementModel.v1';

import {baseSupplementExtensions} from '../supplementHelpers/baseSupplement.extensions';
import {baseSupplementValidators} from '../supplementHelpers/baseSupplement.validators';

AuthoringSupplementModelV1.extend(baseSupplementExtensions);
AuthoringSupplementModelV1.addValidators(baseSupplementValidators);

export {AuthoringSupplementModelV1};
